import {
  GET_ALL_DURATION_DETAILS,
  GET_DURATION_DETAILS_BY_ID,
  GET_ALL_TIMER,
} from '../types'

const INITIAL_STATE = {
  allDurationDetails: [],
  getOneDuration: [],
  getALLTimer:[]
}

const durationReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_DURATION_DETAILS:
      return {
        ...state,
        allDurationDetails: payload.data,
        loader: false,
      }

    case GET_DURATION_DETAILS_BY_ID:
      return {
        ...state,
        getOneDuration: payload.data,
      }

      case   GET_ALL_TIMER:
        return {
          ...state,
          getALLTimer: payload.data,
        }


    default:
      return state
  }
}

export default durationReducer
